/*
 * Copyright (c) 2016-2023 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import isNil from 'ramda/es/isNil';
import sum from 'ramda/es/sum';
import curryN from 'ramda/es/curryN';
export function getMillisecondsFromSeconds(sec) {
    return isNil(sec) ? 0 : Number(sec) * 1000;
}
export const sumAndSubtract = curryN(3, (startValue, add, subtract) => {
    return (startValue || 0) + sum(add || []) - sum(subtract || []);
});
export const compareSumTo = curryN(4, (startValue, add, subtract, compareFn) => {
    return !compareFn ? false : compareFn(sumAndSubtract(startValue, add, subtract));
});
export function getOffesetDifference(minuend, subtrahend) {
    return Math.sign(subtrahend - minuend) * Math.abs(minuend - subtrahend);
}
